<template>
    <div class="list">
        <NavBar></NavBar>
        <!-- 有列表的话不显示  没列表的话显示 -->
        <div v-if="isShow" style="margin-top:60px">
            <van-empty class="custom-image" :image="require('@/assets/Image/custom-empty-image.png')" description="您尚未绑定房屋,请先进行绑定。" />
        </div>
        <!--  -->
        <van-list v-model:loading="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" >
            <div class="HouseCard">
                <van-col span='24' style="font-size:14px;font-weight:bold">威海市南山区XX路11号XXX小区A区11幢2楼201</van-col>
                <van-col span='24' style="font-size:12px;color:gray;margin:6px 0">房屋交易业务编号：100000000000011</van-col>
                <van-row style="margin-top:15px">
                    <van-col span='8' style="text-align:center">
                        <van-col span='24' style="font-size:14px;font-weight:bold">200.00</van-col>
                        <van-col span='24' style="font-size:12px;color:gray;margin-top:6px">建筑面积(㎡)</van-col>
                    </van-col>
                    <van-col span='8' style="text-align:center">
                        <van-col span='24' style="font-size:14px;font-weight:bold">代缴存</van-col>
                        <van-col span='24' style="font-size:12px;color:gray;margin-top:6px">交存状态</van-col>
                    </van-col>
                    <van-col span='8' style="text-align:center">
                        <van-col span='24' style="font-size:14px;font-weight:bold;color:skyblue">20000.00</van-col>
                        <van-col span='24' style="font-size:12px;color:gray;margin-top:6px">账户余额(元)</van-col>
                    </van-col>
                </van-row>
            </div>
        </van-list>
    </div>
</template>

<script>
export default {
    data(){
        return {
            isShow:false,
            loading:false,
            finished:false
        }
    },
    methods:{
        /**
         * 加载数据列表
         */
        onLoad(){
            let data={
                openId:'',
                pageNum:1,
                pageSize:100
            }
            this.$postQuery('/WeChat/getBindHouseListByOpenId', data)
            .then((response)=>{
                console.log(response)
            })
        },
    }
}
</script>

<style scoped>
.list{
    margin-top: 46px;
}
.custom-image>>>.van-empty__image {
    width: 100px;
    height: 100px;
}
.HouseCard{
    border: 1px solid #e0e0e0;
    margin: 10px;
    padding: 15px 10px;
    box-shadow: 0 8px 12px #ebedf0;
    border-radius: 5px;
}
</style>